<template>
	<div class="Capitulo7">
		<h1>DO ALINHAMENTO E DO MELHORAMENTO VIÁRIO</h1>

		<p class="corpo_lei"><strong class="artigo-lei">Art. 102. </strong>Para os fins deste Código, consideram-se fixados os atuais alinhamentos e nivelamento dos logradouros públicos existentes no Município de São Paulo, oficializados ou pertencentes a loteamento aceito ou regularizado, bem como daqueles oriundos de melhoramento viário executado sob a responsabilidade do Poder Público Municipal, Estadual ou Federal.</p>
		<p class="corpo_lei"><strong class="destaque-lei">Parágrafo único. </strong>No caso de indefinição, a pedido do interessado, a Prefeitura deve fornecer o alinhamento e nivelamento, mediante a emissão de certidão.</p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 103. </strong>Enquanto não executados, devem ser observados os novos alinhamentos aprovados constantes das leis de melhoramento viário.</p>
		<p class="corpo_lei"><strong class="destaque-lei">Parágrafo único. </strong>O disposto no “caput” deste artigo não se aplica aos planos de melhoramento publicados anteriormente a 8 de novembro de 1988, data da entrada em vigor da Lei nº 10.676, de 7 de novembro de 1988, desde que não exista declaração de utilidade pública em vigor por ocasião da emissão da aprovação do projeto.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 97. </strong>Desde que não exista declaração de utilidade pública em vigor por ocasião da emissão do Alvará de Aprovação do projeto, não se aplicam, para efeito do licenciamento edilício, os novos alinhamentos aprovados constantes de lei de melhoramento viário e do PRM, publicados anteriormente a 8 de novembro de 1988, inclusive no caso de processos em andamento.</p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 104. </strong>A alteração de alinhamento de logradouro público que importe em alargamento, estreitamento ou retificação, total ou parcial, deve ser objeto de plano de melhoramento viário aprovado por lei.</p>
		<p class="corpo_lei"><strong class="destaque-lei">Parágrafo único. </strong>A alteração de nivelamento de logradouro público, parcial ou em toda sua extensão, pode ser definida por ato do Executivo.</p>
		<p class="corpo_lei"><strong class="bolinha">Art. 105.</strong> É permitida a execução de qualquer obra em imóvel totalmente atingido por plano de melhoramento público e sem declaração de utilidade pública ou de interesse social em vigor, observado o disposto na LOE, PDE e LPUOS.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 1º </strong>No caso de declaração de utilidade pública ou de interesse social em vigor, permite-se a execução de qualquer obra, a título precário, observado o disposto na LOE, PDE e LPUOS, não sendo devida ao proprietário qualquer indenização pela benfeitoria ou acessão quando da execução do melhoramento público.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 2º </strong>Considera-se também como totalmente atingido por melhoramento público o imóvel:</p>
		<p class="corpo_lei"><strong class="destaque-lei">I - </strong>cujo remanescente não possibilite a execução de edificação que atenda ao disposto na LOE, PDE e LPUOS;</p>
		<p class="corpo_lei"><strong class="destaque-lei">II - </strong>no qual, por decorrência de nova situação de nivelamento do logradouro, seja dificultada a implantação de edificações, a critério da Prefeitura.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 98. </strong>O Alvará para imóveis totalmente atingidos por melhoramento público deverá ser emitido com notas contendo: </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">I -</strong> a indicação do número da lei do melhoramento público e da DUP ou DIS em vigor, quando for o caso; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">II -</strong> a indicação da área de terreno e da área necessária ao melhoramento público.<strong class="destaque-decreto"></strong></p>
		<p class="corpo_decreto"><strong class="destaque-decreto">Parágrafo único. </strong>Em se tratando de DUP ou DIS em vigor, por ocasião do despacho de deferimento do Alvará para imóvel totalmente atingido por melhoramento público, deverá ser incluída nota para constar que o Alvará é emitido a título precário, não sendo devida indenização por obras, benfeitorias ou acessão dele decorrentes por ocasião da execução do melhoramento público, nos termos do § 1º do artigo 105 do COE. </p>
		<p class="corpo_lei"><strong class="bolinha">Art. 106. </strong> A edificação nova e as novas partes da edificação existente, nas reformas com aumento de área executadas em imóvel parcialmente atingido por plano de melhoramento público aprovado por lei e sem declaração de utilidade pública ou de interesse social em vigor, devem observar as seguintes disposições:</p>
		<p class="corpo_lei"><strong class="destaque-lei">I - </strong>atender aos recuos mínimos obrigatórios, à taxa de ocupação e ao coeficiente de aproveitamento estabelecidos no PDE e LPUOS, em relação ao lote original;</p>
		<p class="corpo_lei"><strong class="destaque-lei">II - </strong>observar soluções que garantam, após a execução do plano de melhoramento público, o pleno atendimento, pelas edificações remanescentes, das disposições previstas na LOE, PDE e LPUOS em relação ao lote resultante da desapropriação, inclusive com a previsão de demolição total se for o caso.</p>
		<p class="corpo_lei"><strong class="bolinha">Art. 107.</strong> No caso de imóvel parcialmente atingido por plano de melhoramento aprovado por lei e com declaração de utilidade pública ou de interesse social em vigor, a edificação nova e as novas partes da edificação existente nas reformas com aumento de área devem observar os recuos mínimos obrigatórios, a taxa de ocupação e o coeficiente de aproveitamento estabelecidos no PDE e LPUOS e as disposições do COE em relação ao lote resultante da desapropriação.</p>


		<!-- 07_capitulo-VII_d01.html -->
		<div id="g-07_capitulo-VII_d01-box" class="ai2html">
			<div id="g-07_capitulo-VII_d01-01" class="g-artboard g-artboard-v4" data-min-width='960'>
				<img id="g-07_capitulo-VII_d01-01-img" class="g-aiImg" :src="caminho + '07_capitulo-VII_d01-01.png'"/>
				<div id="g-ai0-1" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:1.3599%;margin-top:-9.8px;right:0.2736%;width:129px;">
					<p class="g-pstyle0">Lei Art. 105 - 107</p>
				</div>
				<div id="g-ai0-2" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:1.615%;margin-top:-11.9px;left:0%;width:356px;">
					<p class="g-pstyle1">ALINHAMENTO E MELHORAMENTO VIÁRIO</p>
				</div>
				<div id="g-ai0-3" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:5.3184%;margin-top:-10.6px;left:0.4063%;width:486px;">
					<p class="g-pstyle2">IMÓVEL TOTALMENTE ATINGIDO POR PLANO DE MELHORAMENTO</p>
				</div>
				<div id="g-ai0-4" class="g-Camada_2 g-aiAbs" style="top:11.346%;left:0.1042%;width:25.2083%;">
					<p class="g-pstyle3">SEM DUP/DIS</p>
					<p class="g-pstyle4">Caso o plano de melhoramento público não possua Declaração de Utilidade Pública (DUP) ou Declaração de Interesse Social (DIS) em vigor, é permitida a execução de qualquer obra, observado o disposto na LOE, PDE e LPUOS.</p>
				</div>
				<div id="g-ai0-5" class="g-Camada_2 g-aiAbs" style="top: 14.5%; left: 77.5%; width: 21%;">
					<p class="g-pstyle5">Quando a área restante após execução do melhoramento público não permite qualquer edificação no lote, também considera-se o imóvel <strong>totalmente atingido</strong></p>
				</div>
				<div id="g-ai0-6" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:15.8358%;margin-top:-15.4px;left:58.4872%;width:90px;">
					<p class="g-pstyle6">Alinhamento</p>
					<p class="g-pstyle7">previsto</p>
				</div>
				<div id="g-ai0-7" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:17.3511%;margin-top:-8.1px;left:34.9277%;width:45px;">
					<p class="g-pstyle7">Lote</p>
				</div>
				<div id="g-ai0-8" class="g-Camada_2 g-aiAbs" style="top:26.3389%;left:0.1042%;width:25.2083%;">
					<p class="g-pstyle3">COM DUP/DIS EM VIGOR</p>
					<p class="g-pstyle4">No caso de DUP ou DIS em vigor, permite-se a execução de qualquer obra, a título precário, observado o disposto na LOE, PDE e LPUOS, sem direito a indenização pela benfeitoria.</p>
				</div>
				<div id="g-ai0-9" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:29.9127%;margin-top:-8.1px;left:65.7292%;width:77px;">
					<p class="g-pstyle7">Edificação</p>
				</div>
				<div id="g-ai0-10" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:31.6688%;margin-top:-25.8px;left:32.7354%;width:103px;">
					<p class="g-pstyle8">Área</p>
					<p class="g-pstyle8">atingida pelo</p>
					<p class="g-pstyle9">melhoramento</p>
				</div>
				<div id="g-ai0-11" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:45.6777%;margin-top:-10.6px;left:0.4063%;width:501px;">
					<p class="g-pstyle2">IMÓVEL PARCIALMENTE ATINGIDO POR PLANO DE MELHORAMENTO</p>
				</div>
				<div id="g-ai0-12" class="g-Camada_2 g-aiAbs" style="top:51.057%;left:0.1042%;width:25.2083%;">
					<p class="g-pstyle3">SEM DUP/DIS</p>
					<p><span class="g-cstyle0">A ediﬁcação nova e as novas partes da ediﬁcação existente, nas reformas com aumento de área executadas, além de observar as disposições previstas no PDE e LPUOS, devem prever soluções que garantam, após a execução do plano de melhoramento público, o pleno atendimento, pelas ediﬁcações remanescentes, das disposições previstas na LOE, PDE e LPUOS em relação ao lote resultante da desapropriação, inclusive com a previsão de demolição se for o caso.</span></p>
				</div>
				<div id="g-ai0-13" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:51.837%;margin-top:-10.6px;left:32.6619%;width:265px;">
					<p class="g-pstyle10">PROJETO (SEM DOAÇÃO DE ÁREA)</p>
				</div>
				<div id="g-ai0-14" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:51.8245%;margin-top:-10.5px;left:68.1577%;width:158px;">
					<p class="g-pstyle2"><span class="g-cstyle0">SITUAÇÃO FUTURA</span></p>
				</div>
				<div id="g-ai0-15" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:54.0798%;margin-top:-15.3px;left:32.6619%;width:163px;">
					<p class="g-pstyle7"><span class="g-cstyle37">Recuos e T.O. em função do lote resultante.<br> C.A. em função do lote original</span></p>
				</div>
				<div id="g-ai0-16" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:53.4962%;margin-top:-8.1px;left:68.1639%;width:148px;">
					<p class="g-pstyle7"><span class="g-cstyle37">Recuos, T.O. e C.A. em<br> função do lote resultante</span></p>
				</div>
				<div id="g-ai0-18" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:63.5455%;margin-top:-8.1px;left:32%;width:auto;">
					<p class="g-pstyle7">Alinhamento<br> previsto</p>
				</div>
				<div id="g-ai0-19" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:64.5%;left:94%;width:auto;">
					<p class="g-pstyle7">Área<br> demolida</p>
				</div>
				<div id="g-ai0-21" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:66.998%;margin-top:-33.7px;left:56.6913%;width:139px;">
					<p class="g-pstyle8">Caso DUP ou DIS em<br> vigor: construção a<br> título precário sem<br> direito à indenização</p>
				</div>
				<div id="g-ai0-23" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:68.0218%;margin-top:-8.3px;left:33.1423%;width:122px;">
					<p class="g-pstyle7">Área atingida pelo<br> melhoramento</p>
				</div>
				<div id="g-ai0-24" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:68.7323%;margin-top:-8.1px;left:80.9224%;width:92px;">
					<p class="g-pstyle7">Alinhamento </p>
				</div>
				<div id="g-ai0-26" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:69.7048%;margin-top:-8.1px;left:80.9244%;width:77px;">
					<p class="g-pstyle7">executado</p>
				</div>
				<div id="g-ai0-27" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:76.1499%;margin-top:-10.6px;left:31.9172%;width:268px;">
					<p class="g-pstyle10">PROJETO (COM DOAÇÃO DE ÁREA)</p>
				</div>
				<div id="g-ai0-28" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:76.1374%;margin-top:-10.5px;left:68.1577%;width:158px;">
					<p class="g-pstyle2">SITUAÇÃO FUTURA</p>
				</div>
				<div id="g-ai0-29" class="g-Camada_2 g-aiAbs" style="top:75.8562%;left:0.1042%;width:25.2083%;">
					<p class="g-pstyle3">COM DUP/DIS EM VIGOR</p>
					<p class="g-pstyle11">Em caso de DUP ou DIS em vigor, caso haja execução de edificação na faixa a ser desapropriada, se deve constar nota de que o Alvará é emitido a título precário, sem direito a indenização por obras e benfeitorias.</p>
				</div>
				<div id="g-ai0-30" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:79.2679%;margin-top:-8.1px;left:31.7963%;width:161px;">
					<p class="g-pstyle7"><span class="g-cstyle37">Recuos e T.O. em função do lote<br> resultante. C.A. em função do<br> lote original</span></p>
				</div>
				<div id="g-ai0-33" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:89.4792%;margin-top:-8.1px;left:30.8388%;width:92px;">
					<p class="g-pstyle7">Alinhamento</p>
				</div>
				<div id="g-ai0-34" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:89.4792%;margin-top:-8.1px;left:67.4678%;width:92px;">
					<p class="g-pstyle7">Alinhamento</p>
				</div>
				<div id="g-ai0-35" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:90.6139%;margin-top:-8.1px;left:30.8408%;width:64px;">
					<p class="g-pstyle7">previsto</p>
				</div>
				<div id="g-ai0-36" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:90.6139%;margin-top:-8.1px;left:67.4697%;width:77px;">
					<p class="g-pstyle7">executado</p>
				</div>
				<div id="g-ai0-37" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:95.5115%;margin-top:-15.5px;left:26%;width:165px;">
					<p class="g-pstyle7">Área atingida pelo </p>
					<p class="g-pstyle7">melhoramento a ser doada</p>
				</div>
			</div>
		</div>

		<p class="corpo_lei"><strong class="destaque-lei">§ 1º </strong>Observadas as condições estabelecidas no “caput” deste artigo, fica assegurado, ao proprietário que doar à Prefeitura do Município de São Paulo a parcela do imóvel necessária à execução do melhoramento viário aprovado por lei, o direito de utilizar também essa parcela doada no cálculo do coeficiente de aproveitamento.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 2º </strong>Atendidas as disposições do “caput” deste artigo, a execução de edificação na faixa a ser desapropriada poderá ser permitida pela Prefeitura, a título precário, devendo ser prevista sua demolição total e não sendo devida ao proprietário qualquer indenização pela benfeitoria ou acessão quando da execução do melhoramento público.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 3º </strong>No caso de o melhoramento prever a instituição de faixa não edificável, não se aplica o disposto no § 1º deste artigo, devendo a faixa ser indicada no projeto da edificação e constar do documento a ser emitido.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 99. </strong>O Alvará de imóvel parcialmente atingido por plano de melhoramento público, quando não houver doação de áreas, deverá ser emitido com notas contendo: </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">I -</strong> a indicação do número da lei do melhoramento público e da DUP ou DIS em vigor, quando for o caso; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">II -</strong> a indicação da área do terreno, da área necessária ao melhoramento público e da área remanescente.<strong class="destaque-decreto"></strong></p>
		<p class="corpo_decreto"><strong class="destaque-decreto">Parágrafo único. </strong>Nos casos previstos neste artigo e com DUP ou DIS em vigor, por ocasião do despacho de deferimento do Alvará, na hipótese de execução de edificação na faixa a ser desapropriada, também deverá constar nota de que o Alvará é emitido a título precário, não sendo devida indenização por obras, benfeitorias ou acessão dele decorrentes por ocasião da execução do melhoramento público, nos termos do § 2º do artigo 107 do COE. </p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 100. </strong>A doação de áreas e a comprovação do registro da escritura no Cartório de Registro de Imóveis deverão ocorrer antes da emissão do Alvará de Execução de edificação. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 1º </strong>Admite-se a doação voluntária de melhoramento público, sem DUP ou DIS em vigor, observando-se as disposições do “caput” e do § 1º do artigo 107 do COE. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 2º </strong>Fica delegada aos Coordenadores de SMUL e aos Coordenadores de Planejamento e Desenvolvimento Urbano das PRs, no âmbito de suas atribuições, a competência para representar o Município nas escrituras de doação de áreas necessárias à emissão do Alvará de Execução de edificação. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 3º </strong>A relação de documentos necessários à formalização de escritura de doação, a padronização de minutas de escritura e as respectivas rotinas serão estabelecidas em portaria do Secretário de SMUL.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 101. </strong>Quando a lei de melhoramento previr a instituição de faixa de servidão não edificável, com ou sem DUP em vigor, não será lavrada escritura de doação ou de servidão, devendo a faixa ser indicada no projeto da edificação e o Alvará ser emitido com nota indicando o número da respectiva lei de melhoramento público, a metragem da área não edificável e sua localização aproximada dentro dos limites do imóvel.</p>
		
	</div>
</template>

<script>
export default{
	name: "Capitulo7", 
	props:['caminho']
}
</script>

<style lang="scss">
@import '../assets/main.scss';

/* 07_capitulo-VII_d01.html */
#g-07_capitulo-VII_d01-box .g-artboard {
	margin:0 auto;
}
#g-07_capitulo-VII_d01-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-07_capitulo-VII_d01-01 {
	position:relative;
	overflow:hidden;
	width:960px;
}
#g-07_capitulo-VII_d01-01 p {
	/*font-family:arial,helvetica,sans-serif;*/
	font-size:14px;
	line-height:17px;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0.01em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
	height:auto;
}
#g-07_capitulo-VII_d01-01 .g-pstyle0 {
	height:17px;
	letter-spacing:0em;
	text-align:right;
}
#g-07_capitulo-VII_d01-01 .g-pstyle1 {
	font-weight:bold;
	font-size:16px;
	line-height:19px;
	height:19px;
	letter-spacing:-0.003em;
}
#g-07_capitulo-VII_d01-01 .g-pstyle2 {
	font-weight:bold;
	height:17px;
}
#g-07_capitulo-VII_d01-01 .g-pstyle3 {
	font-weight:bold;
	letter-spacing:0em;
}
#g-07_capitulo-VII_d01-01 .g-pstyle4 {
	line-height:19px;
}
#g-07_capitulo-VII_d01-01 .g-pstyle5 {
	line-height:18px;
	letter-spacing:0em;
}
#g-07_capitulo-VII_d01-01 .g-pstyle6 {
	font-size:12px;
	line-height:14px;
	height:14px;
	letter-spacing:-0.015em;
}
#g-07_capitulo-VII_d01-01 .g-pstyle7 {
	font-size:12px;
	line-height:14px;
	height:14px;
	letter-spacing:0em;
}
#g-07_capitulo-VII_d01-01 .g-pstyle8 {
	font-size:12px;
	line-height:16px;
	height:16px;
	letter-spacing:0em;
}
#g-07_capitulo-VII_d01-01 .g-pstyle9 {
	font-size:12px;
	line-height:16px;
	height:16px;
	letter-spacing:-0.014em;
}
#g-07_capitulo-VII_d01-01 .g-pstyle10 {
	font-weight:bold;
	height:17px;
	letter-spacing:0em;
}
#g-07_capitulo-VII_d01-01 .g-pstyle11 {
	line-height:17px;
}
#g-07_capitulo-VII_d01-01 .g-cstyle0 {
	letter-spacing:0.009em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle1 {
	letter-spacing:0em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle2 {
	letter-spacing:-0.01em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle3 {
	letter-spacing:-0.009em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle4 {
	letter-spacing:-0.008em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle5 {
	letter-spacing:-0.076em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle6 {
	letter-spacing:0.02em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle7 {
	letter-spacing:-0.021em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle8 {
	letter-spacing:0.001em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle9 {
	letter-spacing:-0.022em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle10 {
	letter-spacing:0.015em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle11 {
	letter-spacing:0.006em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle12 {
	letter-spacing:-0.023em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle13 {
	letter-spacing:-0.044em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle14 {
	letter-spacing:0.017em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle15 {
	letter-spacing:0.023em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle16 {
	letter-spacing:0.005em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle17 {
	font-weight:bold;
}
#g-07_capitulo-VII_d01-01 .g-cstyle18 {
	letter-spacing:-0.016em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle19 {
	letter-spacing:-0.026em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle20 {
	letter-spacing:-0.019em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle21 {
	letter-spacing:-0.045em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle22 {
	letter-spacing:0.016em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle23 {
	letter-spacing:-0.002em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle24 {
	letter-spacing:0.022em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle25 {
	letter-spacing:-0.013em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle26 {
	letter-spacing:-0.272em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle27 {
	letter-spacing:-0.015em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle28 {
	letter-spacing:-0.048em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle29 {
	letter-spacing:-0.025em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle30 {
	letter-spacing:-0.267em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle31 {
	letter-spacing:0.003em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle32 {
	letter-spacing:-0.003em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle33 {
	letter-spacing:-0.268em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle34 {
	letter-spacing:-0.02em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle35 {
	letter-spacing:0.007em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle36 {
	letter-spacing:-0.012em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle37 {
	letter-spacing:-0.006em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle38 {
	letter-spacing:-0.07em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle39 {
	letter-spacing:-0.069em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle40 {
	letter-spacing:-0.001em;
}
#g-07_capitulo-VII_d01-01 .g-cstyle41 {
	letter-spacing:-0.033em;
}
</style>


// WEBPACK FOOTER //
// src/components/Capitulo7.vue